import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import EventBus from "./utils/eventBus";
import { Getter } from "vuex-class";
import * as types from "@/store/constants/types";
import getMyReport from "@/components/getMyReport/getMyReport.vue";
import toast from "@/components/toast/toast.vue";
import VipToast from "@/components/vipToast/VipToast.vue";
import VipPurchaseSuccessToast from "@/components/vipToast/VipPurchaseSuccessToast.vue";
import VipFixButton from "@/components/vipFixButton/vipFixButton.vue";
import GeneralUtilsHelper from "@/utils/generalUtils";
Component.registerHooks(["beforeRouteEnter", "beforeRouteLeave" // "beforeRouteUpdate" // for vue-router 2.2+
]);

var App =
/*#__PURE__*/
function (_Vue) {
  _inherits(App, _Vue);

  function App() {
    var _this;

    _classCallCheck(this, App);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(App).apply(this, arguments));
    _this.enterTransitionName = "animated slideInLeft";
    _this.leaveTransitionName = "animated slideOutRight";
    _this.includeRoutes = ["HoroscopeDetails", // "ethnicityScanner",
    "horoscopePage", "personalFutrue", "home", "galleryResult", "articalResult", 'readListPage'];
    _this.isShowGetReport = false;
    _this.goBackFn = null;
    _this.getMyReport = null;
    _this.iconColor = false;
    _this.title = "";
    _this.headImg = "";
    _this.animate_name = "";
    _this.titleColor = "";
    _this.buttonStatus = "";
    _this.loading_text = "";
    _this.requestResult = null;
    _this.changeData = false;
    _this.rateUsFn = null;
    return _this;
  }

  _createClass(App, [{
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      // this.initial();
      EventBus.$on("router-transition-type", function (content) {
        // console.log("$on router-transition-type:", {
        //   content,
        //   timeStamp: new Date().valueOf()
        // });
        switch (content) {
          case "back":
            _this2.enterTransitionName = "animated slideInLeft";
            _this2.leaveTransitionName = "animated slideOutRight";
            break;

          case "forward":
            _this2.enterTransitionName = "animated slideInRight";
            _this2.leaveTransitionName = "animated slideOutLeft";
            break;

          case "down":
            _this2.enterTransitionName = "animated slideInDown";
            _this2.leaveTransitionName = "animated slideOutDown";
            break;

          case "up":
            _this2.enterTransitionName = "animated slideInUp";
            _this2.leaveTransitionName = "animated slideOutUp";
            break;

          case "static":
            _this2.enterTransitionName = "";
            _this2.leaveTransitionName = "";

          default:
            break;
        }
      });
      EventBus.$on("isShowGetMyReport", function (value) {
        _this2.isShowGetReport = value.isShow;
        _this2.goBackFn = value.closeFn;
        _this2.getMyReport = value.reportFn;
        _this2.iconColor = value.color;
        _this2.title = value.title;
        _this2.headImg = value.headImg;
        _this2.animate_name = value.animate;
        _this2.buttonStatus = value.buttonStatus ? value.buttonStatus : "get";
        _this2.loading_text = value.loading_text;
        _this2.requestResult = value.requestResult;
        value.titleColor ? _this2.titleColor = value.titleColor : void 0;
        _this2.changeData = !_this2.changeData;
        _this2.rateUsFn = value.rateUsFn;
      });
    }
  }, {
    key: "isShowVipBtn",
    get: function get() {
      return this.cardClickTime >= 2 && this.$route.path === "/home" && !GeneralUtilsHelper.isVip();
    }
  }]);

  return App;
}(Vue);

tslib_1.__decorate([Getter(types.GETTER_CARD_CLICK_TIMES)], App.prototype, "cardClickTime", void 0);

App = tslib_1.__decorate([Component({
  components: {
    getMyReport: getMyReport,
    toast: toast,
    VipToast: VipToast,
    VipPurchaseSuccessToast: VipPurchaseSuccessToast,
    VipFixButton: VipFixButton
  }
})], App);
export default App;